<script setup lang="ts">
import type { Component } from 'vue';
import { DropdownMenuSubTrigger } from 'reka-ui';

withDefaults(
    defineProps<{
        label?: string;
        icon?: Component;
        disabled?: boolean;
    }>(),
    {
        disabled: false,
    },
);
</script>

<template>
    <DropdownMenuSubTrigger
        :disabled="disabled"
        class="text-muval-gray-1 hover:bg-muval-gray-6 data-highlighted:bg-muval-gray-6 flex cursor-pointer items-center rounded-sm px-3 py-2 text-sm outline-hidden transition-colors"
    >
        <component
            :is="icon"
            v-if="icon"
            class="text-muval-gray-2 mr-2 size-5 shrink-0"
        />
        <span
            v-if="label"
            class="flex-1 truncate"
            >{{ label }}</span
        >
        <slot v-else />
        <SvgIcon
            name="system-chevron-right"
            class="text-muval-gray-3 ml-auto size-4"
        />
    </DropdownMenuSubTrigger>
</template>
